import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-reveal";
import {
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";

const Settingpage = () => {
  const navigate = useNavigate();

  return (
    <Fade>
      <section className="home_banner_main buy_page position-relative">
        <div className="top_circle"></div>

        <Container className="position-relative container_postition">
          <div className="setting_inner text-start">
            <Form>
              <Row>
                <Col lg={6} md={6} sm={12}>
                  <div className="setting_white_box bg-white p-3 rounded">
                    <h5 className="box_heading mb-4">Change Password</h5>

                    <div className="input_box mb-4">
                      <FormGroup>
                        <Label for="exampleEmail">Old password</Label>
                        <Input
                          type="password"
                          name="email"
                          id="exampleEmail"
                          placeholder="Type your old password"
                          className="border-bottom"
                        />
                      </FormGroup>
                    </div>

                    <div className="input_box mb-4">
                      <FormGroup>
                        <Label for="exampleEmail">New password</Label>
                        <Input
                          type="password"
                          name="email"
                          id="exampleEmail"
                          placeholder="Type your new password"
                          className="border-bottom"
                        />
                      </FormGroup>
                    </div>

                    <div className="input_box">
                      <FormGroup>
                        <Label for="exampleEmail">Repeat new password</Label>
                        <Input
                          type="password"
                          name="email"
                          id="exampleEmail"
                          placeholder="Repeat your new password"
                          className="border-bottom"
                        />
                      </FormGroup>
                    </div>

                    <div className="info_box_here d-flex align-items-center gap-2 mt-4">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.003033 5.6003 -0.13559 7.00776 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0ZM5.83334 3.00417C5.83334 2.77342 5.90176 2.54786 6.02995 2.356C6.15815 2.16414 6.34036 2.01461 6.55354 1.92631C6.76672 1.838 7.0013 1.8149 7.22761 1.85992C7.45392 1.90493 7.6618 2.01605 7.82496 2.17921C7.98812 2.34237 8.09923 2.55025 8.14425 2.77656C8.18927 3.00287 8.16616 3.23745 8.07786 3.45063C7.98956 3.66381 7.84002 3.84602 7.64817 3.97421C7.45631 4.10241 7.23075 4.17083 7 4.17083C6.84196 4.17874 6.68395 4.15442 6.5356 4.09935C6.38725 4.04427 6.25166 3.95959 6.13707 3.85045C6.02248 3.74132 5.93129 3.61002 5.86904 3.46453C5.8068 3.31904 5.7748 3.16241 5.775 3.00417H5.83334ZM9.91667 10.5C9.91667 10.6547 9.85521 10.8031 9.74581 10.9125C9.63642 11.0219 9.48804 11.0833 9.33333 11.0833H5.25C5.09529 11.0833 4.94692 11.0219 4.83752 10.9125C4.72813 10.8031 4.66667 10.6547 4.66667 10.5C4.66667 10.3453 4.72813 10.1969 4.83752 10.0875C4.94692 9.97812 5.09529 9.91667 5.25 9.91667H6.41667V6.41667H5.83334C5.67863 6.41667 5.53025 6.35521 5.42086 6.24581C5.31146 6.13642 5.25 5.98804 5.25 5.83333C5.25 5.67862 5.31146 5.53025 5.42086 5.42085C5.53025 5.31146 5.67863 5.25 5.83334 5.25H8.16667V9.91667H9.33333C9.48804 9.91667 9.63642 9.97812 9.74581 10.0875C9.85521 10.1969 9.91667 10.3453 9.91667 10.5Z"
                            fill="#560AB5"
                          />
                        </svg>
                      </span>
                      <p>
                        Once password is changed you will be logged out on all
                        other devices
                      </p>
                    </div>

                    <Button className="btn_theme border-0 py-2 px-4 mt-4">
                      Save
                    </Button>
                  </div>
                </Col>

                <Col lg={6} md={6} sm={12}>
                  <div className="setting_white_box bg-white p-3 rounded">
                    <div className="goole_disconnect">
                      <h5 className="box_heading mb-4">Google</h5>
                      <img
                        src="/images/google_dis.png"
                        alt=""
                        className="img-fluid"
                      />

                      <p>
                        Disconnect from current social network to connect with
                        another one
                      </p>

                      <Button className="Disconnect">Disconnect</Button>
                    </div>

                    <div className="email_setting mt-5">
                      <h5 className="box_heading mb-4">Email settings</h5>

                      <div className="email_chnge">
                        <FormGroup className="position-relative d-flex gap-2">
                          <div className="emial_setting_div d-flex position-relative">
                            <Input
                              type="email"
                              name="email"
                              id="exampleEmail"
                              placeholder="Dsuffescom@gmail.com"
                            />

                            <Button className="btn-editemail p-0">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <g opacity="0.7">
                                  <path
                                    d="M4.16667 15.8332H5.33333L12.5208 8.64567L11.3542 7.479L4.16667 14.6665V15.8332ZM16.0833 7.43734L12.5417 3.93734L13.7083 2.77067C14.0278 2.45123 14.4203 2.2915 14.8858 2.2915C15.3514 2.2915 15.7436 2.45123 16.0625 2.77067L17.2292 3.93734C17.5486 4.25678 17.7153 4.64234 17.7292 5.094C17.7431 5.54567 17.5903 5.93095 17.2708 6.24984L16.0833 7.43734ZM14.875 8.6665L6.04167 17.4998H2.5V13.9582L11.3333 5.12484L14.875 8.6665ZM11.9375 8.06234L11.3542 7.479L12.5208 8.64567L11.9375 8.06234Z"
                                    fill="black"
                                  />
                                </g>
                              </svg>
                            </Button>
                          </div>
                          <Button className="btn-chnge p-0">change</Button>
                        </FormGroup>

                        <div className="btn_twwo mt-4">
                          <Button className="Disconnect w-100 py-3">Manage your email preferences</Button>
                          <Button className="delte_account w-100 py-3 mt-3">Delete account</Button>

                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        </Container>
        <div className="bottom_circle"></div>
      </section>
    </Fade>
  );
};

export default Settingpage;
